import React from "react";

const SvgComponent = props => (
  <svg viewBox="0 0 2048 2048" width="1em" height="1em" {...props}>
    <path
      className="OfficeIconColors_m22"
      d="M1459 1434l-147-410H741l-143 410H461L968 102h124l504 1332M1027 265h-4L783 923h487z"
    />
  </svg>
);

export default SvgComponent;
